<template>
    <div
        class="frontend-style frontend-products-style"
        v-scrolling="handleScroll"
    >
        <article v-if="CataNowList">
            <transition-group
                tag="div"
                class="productBanner"
                enter-active-class="animated fadeIn"
                leave-active-class="animated fadeOut"
            >
                <div
                    v-for="(item, key) in CataNowList"
                    :key="key"
                    v-if="key == categoryNow"
                    :style="{ backgroundImage: 'url(' + item.bannerPath + ')' }"
                ></div>
            </transition-group>
            <div class="filter"></div>
            <ul>
                <li class="cataMobileWrapper">
                    <div class="cataSwitchMobile" @click="goMobileCata">
                        <img :src="Images.Mobile.search.switch" alt="" />
                        <h4>{{ CataNowList[categoryNow][locales] }}</h4>
                    </div>
                </li>
                <li
                    v-for="(item, key) in CataNowList"
                    :key="key"
                    @click="switchCata(item[locales], key)"
                    class="cursorPoint cataMobileOther"
                    :class="key == categoryNow ? 'actived' : ''"
                >
                    <transition enter-active-class="fadeIn">
                        <img
                            :src="item.iconPath"
                            :alt="item[locales]"
                            v-if="key == categoryNow"
                        />
                    </transition>
                    <h4>{{ item[locales] }}</h4>
                </li>
            </ul>
        </article>
        <section>
            <Search
                v-if="products && locales"
                @searching="getKeyword"
                :MobileFix="fixBar"
                :YentekWire="YentekWire"
            >
                <template v-slot:productList>
                    <transition-group
                        v-if="showResult.length != 0"
                        name="catalist"
                        mode="out-in"
                        tag="div"
                        class="productList"
                        enter-active-class="animated fadeInRight"
                    >
                        <div
                            v-for="item in showResult"
                            class="cursorPoint card"
                            ref="cards"
                            :key="item.id"
                            @click="popUp({ id: item.id, name: item.name_CH })"
                        >
                            <div>
                                <img :src="item.imagePath" alt="" />
                            </div>
                            <div>
                                <h5>{{ item[locales] }}</h5>
                            </div>
                        </div>
                    </transition-group>
                </template>
                <template v-slot:YentekWire>
                    <div
                        v-if="YentekWire && YentekOrWire"
                        class="wrapper-yentekWire"
                        :style="
                            YentekOrWire == 'Wire'
                                ? {
                                      backgroundImage: `url(${wireImage.background})`,
                                      backgroundSize: 'cover',
                                  }
                                : {}
                        "
                    >
                        <div
                            class="wrapper"
                            v-if="YentekOrWire == 'Yentek'"
                            :style="`background-image:url(${yentekImage.bg})`"
                        >
                            <div class="logo-wrapper">
                                <div class="logo-text">
                                    <img
                                        :src="yentekImage.yentek_banner"
                                        alt=""
                                        class="yentek-logo"
                                    />
                                    <p>
                                       {{$t("Products.branding.yentek.summary")}}
                                    </p>
                                </div>
                            </div>
                            <div class="wrapper-yentek-image">
                                <ul>
                                    <li>
                                        <div>
                                            <h4>{{$t("Products.branding.yentek.paragraph01.title")}}</h4>
                                            <p>
                                                {{$t("Products.branding.yentek.paragraph01.para")}}
                                            </p>
                                        </div>
                                        <img
                                            :src="yentekImage.yentek_chart_01"
                                            alt=""
                                        />
                                    </li>
                                    <li>
                                        <img
                                            :src="yentekImage.yentek_chart_02"
                                            alt=""
                                        />
                                        <div>
                                            <h4>{{$t("Products.branding.yentek.paragraph02.title")}}</h4>
                                            <p>
                                                {{$t("Products.branding.yentek.paragraph02.para")}}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                        <div
                            class="wrapper"
                            v-if="YentekOrWire == 'Wire'"
                            style="background-color: rgba(0, 0, 0, 0.2)"
                        >
                            <div class="logo-wrapper">
                                <div class="logo-text">
                                    <img
                                        :src="wireImage.logo"
                                        alt=""
                                        class="wire-logo"
                                    />
                                    <p class="wire-text">
                                    {{$t("Products.branding.honchi.summary")}}
                                    </p>
                                </div>
                            </div>
                            <div
                                class="wrapper-yentek-image cf-image"
                                v-if="Images"
                            >
                                <ul>
                                    <li>
                                        <div>
                                            <h4>{{$t("Products.branding.honchi.paragraph01.title")}}</h4>
                                            <p>
                                                {{$t('Products.branding.honchi.paragraph01.para')}}
                                            </p>
                                        </div>
                                        <ol>
                                            <li v-for="cf in Images.Quality.cf">
                                                <img :src="cf" alt="" />
                                            </li>
                                        </ol>
                                    </li>
                                    <li>
                                        <ol>
                                            <li v-for="eq in wireImage02"> 
                                               <img :src="eq" alt=""> 
                                            </li>
                                        </ol>
                                        <div>
                                            <h4>{{$t("Products.branding.honchi.paragraph02.title")}}</h4>
                                            <p>
                                                {{$t('Products.branding.honchi.paragraph02.para')}}
                                            </p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </template>
            </Search>
        </section>
        <div
            class="pdf"
            :style="{ backgroundImage: 'url(' + Images.Home.banner.bg + ')' }"
            v-if="Images"
            ref="pdfBox"
        >
            <div class="filter"></div>
            <div class="dmBox">
                <div class="cursorPoint" @click="goPdf">
                    {{ $t("Products.pdf.open") }}
                </div>
                <a href="./static/soonport_download.pdf" target="_blank">
                    <div class="cursorPoint">
                        {{ $t("Products.pdf.download") }}
                    </div>
                </a>
            </div>
            <h4>{{ $t("Products.pdf.title") }}</h4>
        </div>
    </div>
</template>
<script>
import { mapState, mapGetters, mapActions } from "vuex";
import yentek_banner from "../../assets/images/yentek_banner.jpg";
import yentek_chart_01 from "../../assets/images/yentek_chart-10.png";
import yentek_chart_02 from "../../assets/images/yentek_chart-11.png";
import HongChi_logo_website from "../../assets/images/HongChi_logo_website.png";
import HongChi_logo_website_background from "../../assets/images/Manu_F_.jpg";
import yentek_bg from "../../assets/images/cup-spray-gun-5360677.png";
import HonChi_manu01 from "../../assets/images/equipment-04@2x.png"
import HonChi_manu02 from "../../assets/images/equipment-06@2x.png"
import HonChi_manu03 from "../../assets/images/equipment-03@2x.png"

export default {
    name: "products",
    data() {
        return {
            searchText: "",
            searchScroll: 0,
            fixBar: false,
            dTimer: null,
            yentekImage: {
                yentek_banner: yentek_banner,
                yentek_chart_01: yentek_chart_01,
                yentek_chart_02: yentek_chart_02,
                bg: yentek_bg,
            },
            wireImage: {
                logo: HongChi_logo_website,
                background: HongChi_logo_website_background,
            },
            wireImage02:[HonChi_manu01,HonChi_manu02,HonChi_manu03]
        };
    },
    components: {},
    computed: {
        ...mapState("frontend", [
            "products",
            "categories",
            "locales",
            "Images",
            "categoryNow",
        ]),
        ...mapState("analytic", ["clientId"]),
        ...mapGetters("frontend", ["CataNowList", "Mobile"]),
        bannerNow() {
            if (this.CataNowList && this.categoryNow) {
                return this.CataNowList[this.categoryNow];
            }
        },
        YentekWire() {
            if (this.bannerNow) {
                return this.bannerNow.id == "E6xxLD026ormxXqfBZiu" ||
                    this.bannerNow.id == "gbei2OTYevrQBYHPTtF6"
                    ? true
                    : false;
            }
        },
        YentekOrWire() {
            if (this.YentekWire)
                return this.bannerNow.id == "E6xxLD026ormxXqfBZiu"
                    ? "Yentek"
                    : "Wire";
        },
        showResult() {
            const newArr = this.products.filter((item) =>
                this.categoryNow == "AllProduct"
                    ? item
                    : item.cateId == this.categoryNow
            );

            const conditions = this.searchText.split(" ");
            const rslt = newArr.filter((i) => {
                const text = i[this.locales].toLowerCase();
                return conditions
                    .map((el) => text.includes(el.toLowerCase()))
                    .every((bl) => bl)
                    ? i
                    : false;
            });
            return rslt;
        },
    },
    methods: {
        ...mapActions("frontend", ["changeCategory"]),
        switchCata(name, cateId) {
            const payload = { name: name, id: cateId };
            this.changeCategory(payload);
        },
        getKeyword(val) {
            this.searchText = val;
        },
        popUp(query) {
            this.sendEvent(query.name);
            this.$router.replace({ query: { id: query.id, Popup: "product" } });
        },
        sendEvent(product) {
            this.$gtag.event("客戶產品點擊", {
                event_category: this.clientId,
                event_label: `產品_${product}`,
                value: 200,
            });
        },
        goPdf() {
            this.$gtag.event("客戶DM互動", {
                event_category: this.clientId,
                event_label: `客戶點閱DM`,
                value: 200,
            });
            this.$router.replace({ query: { Popup: "dm" } });
        },
        handleScroll() {
            this.searchScroll = window.scrollY;
        },
        goMobileCata() {
            this.$router.replace({ query: { Popup: "category" } });
        },
        debounce(fn, wait) {
            if (this.dTimer !== null) {
                clearTimeout(this.dTimer);
            }
            this.dTimer = setTimeout(fn, wait);
        },
        Toggle(height, val) {
            this.fixBar = val > 230 && height - 100 > val ? true : false;
        },
    },
    mounted() {},
    watch: {
        searchScroll(val) {
            const Height = this.$refs.pdfBox.offsetTop;
            this.debounce(this.Toggle(Height, val), 300);
        },
    },
};
</script>
